import { CustomStorageProvider } from './../../providers/custom-storage/custom-storage';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../util/Constants';

/**
 * Generated class for the ConvertDatePipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'convertDate',
  pure: false
})
export class ConvertDatePipe implements PipeTransform {

  constructor(public translateService: TranslateService,
      public customStorageService: CustomStorageProvider) {

  }
  /**
   * Takes a value and makes it lowercase.
   */
  transform(sDate: string, locale: string) {
    return this.convertLocalDateString(sDate);
  }

  convertLocalDateString(sDate: string) {
    var langName = this.customStorageService.get(Constants.STORAGE_KEY_LANG);
		var currentMonth = Number(sDate.substring(5,7));
		var currentDate = Number(sDate.substring(8,10));
		var currentHour = Number(sDate.substring(11,13));
		var currentMinute = Number(sDate.substring(14,16));
		var currentSec = Number(sDate.substring(17,19));
		var displayMonth = "";
		var displayHour = 0;
		var isPM = false;

		switch(currentMonth) {
			case 1 :
				displayMonth = this.translateService.instant("January");
				break;
			case 2 :
				displayMonth = this.translateService.instant("February");
				break;
			case 3 :
				displayMonth = this.translateService.instant("March");
				break;
			case 4 :
				displayMonth = this.translateService.instant("April");
				break;
			case 5 :
				displayMonth = this.translateService.instant("May");
				break;
			case 6 :
				displayMonth = this.translateService.instant("June");
				break;
			case 7 :
				displayMonth = this.translateService.instant("July");
				break;
			case 8 :
				displayMonth = this.translateService.instant("August");
				break;
			case 9 :
				displayMonth = this.translateService.instant("September");
				break;
			case 10 :
				displayMonth = this.translateService.instant("October");
				break;
			case 11 :
				displayMonth = this.translateService.instant("November");
				break;
			case 12 :
				displayMonth = this.translateService.instant("December");
				break;
		}

		if (currentHour == 0) {
			displayHour = (currentHour + 12);
		} else if (currentHour > 12) {
			displayHour = (currentHour - 12);
			isPM = true;
		} else if  (currentHour == 12) {
			displayHour = currentHour;
			isPM = true;
		} else {
			displayHour = currentHour;
		}
		var timeStr = "";
		if (isPM) {
			timeStr = this.translateService.instant("PM");
		} else {
			timeStr = this.translateService.instant("AM");
		}
		if (langName == Constants.LANG_ZH_CN || langName == Constants.LANG_ZH_TW) {
      return displayMonth + currentDate + this.translateService.instant("Day") + " " + timeStr
          + this.pad(displayHour, 2) + ":" +  this.pad(currentMinute, 2) + ":" + this.pad(currentSec, 2);
    } else {
      return currentDate + " " + displayMonth + ", " + this.pad(displayHour, 2) + ":" + this.pad(currentMinute, 2)
          + ":" + this.pad(currentSec, 2) + this.pad(timeStr, 2);
    }
  }

  pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/convert-date/convert-date.ts